import { PuiSelectOption } from '@/models/pebble-ui';

export const mapToSelectOption = (years: number[]): PuiSelectOption<number>[] => {
    return years.map(e => ({
        label: e.toString(),
        value: e,
    }));
};